import type { UseCase } from '@contexts/shared/application';
import type { User, UserRepository } from '@contexts/users/domain';

export type GetLoggedUserUseCase = UseCase<void, User>;

export function getLoggedUserBuilder(userRepository: UserRepository): GetLoggedUserUseCase {
	return async function getLoggedUser(): Promise<User> {
		return userRepository.getLoggedUser();
	};
}
